module.exports = __webpack_public_path__ + "static/media/ams.b46bc1dd.jpg";